import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined";
import { Button, Grid, Tooltip } from "@mui/material";
import { useFormikContext } from "formik";
import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getResponsable, getResponsables } from "../../../../redux/actions/empleador";
import { StyledResponsablesCard } from "../../../styled/Responsables";
import FormikAutocomplete from "../../formik/FormikAutocomplete";

const ResponsablesCard = ({
  name,
  responsableType = null,
  title,
  handleOpenAddResponsable,
  handleEditResponsable,
  required,
  fieldLabel,
  variant = "default",
  isDatos = false,
  validateHorasMensuales = false,
  horasFieldName = null,
}) => {
  const { values, setFieldValue, setFieldTouched } = useFormikContext();
  const dispatch = useDispatch();
  const responsables = useSelector((state) => responsableType ?
    state.empleador.responsables?.[isDatos ? "datos" : "" + responsableType]?.data ?? []
    : state.empleador.responsables.data
  );
  const latestSelectionRef = useRef(null);

  const xs = variant === "vertical" ? 10 : 11;
  const selectedId = values?.[name];
  const hasSelection = selectedId && selectedId !== "";

  const handleResponsableChange = (value) => {
    if (!validateHorasMensuales || !horasFieldName) return;

    const selectedResponsableId = value?.id ?? null;
    latestSelectionRef.current = selectedResponsableId;

    setFieldValue(horasFieldName, null, false);
    if (!selectedResponsableId) {
      return;
    }

    dispatch(getResponsable(selectedResponsableId))
      .then((response) => {
        if (latestSelectionRef.current !== selectedResponsableId) return

        const horasMensuales = response?.value?.data?.horasMensuales;
        const horasNormalizadas = horasMensuales === null || horasMensuales === undefined
          ? null
          : Number(horasMensuales);

        setFieldValue(horasFieldName, horasNormalizadas, true);

        if (horasNormalizadas === null || horasNormalizadas <= 0) {
          setFieldTouched(name, true, false);
        }
      })
      .catch(() => {
        if (latestSelectionRef.current === selectedResponsableId) {
          setFieldValue(horasFieldName, null, true);
          setFieldTouched(name, true, false);
        }
      });
  };

  return (
    <StyledResponsablesCard.Card>
      <StyledResponsablesCard.Title variant="h6">
        {title}
      </StyledResponsablesCard.Title>

      <Grid container spacing={1}>
        <Grid item xs={xs}>
          <FormikAutocomplete
            name={name}
            label={(fieldLabel ?? title) + (required ? " *" : "")}
            options={responsables}
            renderOption={(option) => option.nombre}
            filterOptions={(option) => option.nombre}
            getOptions={() => dispatch(getResponsables(responsableType, isDatos))}
            callBack={handleResponsableChange}
          />
        </Grid>
        <StyledResponsablesCard.IconAligned
          item
          xs={12 - xs}
        >
          <Tooltip title={`Agregar ${title}`} arrow>
            <Button
              color="primary"
              variant="contained"
              onClick={() => handleOpenAddResponsable(name, responsableType, isDatos)}
              sx={{ minWidth: 'auto', px: 1 }}
            >
              <StyledResponsablesCard.Icon component={PersonAddAltOutlinedIcon} />
            </Button>
          </Tooltip>
          {handleEditResponsable && hasSelection && (
            <Tooltip title={`Editar ${title}`} arrow>
              <Button
                color="secondary"
                variant="contained"
                onClick={() => handleEditResponsable(name, responsableType, selectedId, isDatos)}
                sx={{ minWidth: 'auto', px: 1, ml: 0.5 }}
              >
                <StyledResponsablesCard.Icon component={EditOutlinedIcon} />
              </Button>
            </Tooltip>
          )}
        </StyledResponsablesCard.IconAligned>
      </Grid>

    </StyledResponsablesCard.Card>
  )
}

export default ResponsablesCard;


